<template>
    <div id="CompaniesList">
        <b-container>
            <b-row v-if="all=='true'">
            <b-col cols="4">
                <b-form-input
                    v-model.trim="prefName"
            ></b-form-input>
            </b-col>
            <b-col cols="1">
                <b-button variant="outline" @click="search()" aria-label="Search"><span class="exper2"><font-awesome-icon icon="search" size="lg"  /></span> </b-button>
            </b-col>
            </b-row>
            <b-table
                    id="listTableC"
                    selectable
                    :items="items"
                    :fields="fields"
                    :per-page=0
                    :current-page="curPage"
                    :key="myKey"
                    striped
                    head-row-variant="info"
                    @row-selected="onRowSelected"
            >
            </b-table>

            <b-pagination v-if="rows>10"
                          v-model="curPage"
                          :total-rows="rows"
                          :per-page="perPage"
                          aria-controls="listTableC"
                          align="center"
                          pills
            ></b-pagination>

            <br><br>

            <div class="modalConf">
                <b-modal id="modalConf">
                    <div class="d-block text-center">
                        <h4>{{$t('SURE')}}</h4>
                    </div>
                    <template v-slot:modal-footer="{ cancel }">
                        <b-button variant="success" @click="cancel()">{{$t('CANCEL')}}</b-button>
                        <b-button variant="danger" @click="canAct()">{{$t('GO_ON')}}</b-button>
                    </template>
                </b-modal>
            </div>

        </b-container>

        <b-container fluid class = "footer text-center">

            <center>
                <b-form-radio-group id="radio-group-2" v-model="selected" name="radio-sub-component">
                    <a v-b-popover.hover.top="this.$t('SHOW')" title="" class="shBt">
                        <b-form-radio value="Company"><font-awesome-icon icon="eye" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('OUTINGS')" title="">
                        <b-form-radio value="CompanyOutingsList"><font-awesome-icon icon="folder-open" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('REF_GEO')" title="" v-if="admin">
                        <b-form-radio value="RefAdd"><font-awesome-icon icon="book" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('EDIT')" title="">
                        <b-form-radio value="ManageCompany"><font-awesome-icon icon="edit" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('DELETE')" title="" v-if="author || admin" class="shBt">
                        <b-form-radio value="deleteCompany"><font-awesome-icon icon="trash-alt" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('HELP')" title="" v-if="author || admin" class="shBt">
                        <b-button class="m-1" @click.stop.prevent="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
                    </a>
                </b-form-radio-group>
            </center>

        </b-container>

        <Help
                v-on:closeHelp="showHelp=false"
                v-bind:helpName="helpName"
                v-if="showHelp"
        />

    </div>

</template>

<script>
import { BRow, BCol, BContainer, BModal, BTable, BPagination, BButton, BFormRadio, BFormRadioGroup, BFormInput } from 'bootstrap-vue';
import Help from "./Help.vue";

export default {
  name: 'CompaniesList',
  components: {
    Help,
    BRow, BCol, BContainer, BModal, BTable, BPagination, BButton, BFormRadio, BFormRadioGroup, BFormInput
  },
  data: function() {
    return {
        fields: [
          {
            key: 'companyName',
            label: this.$t('COM_NAME'),
            sortable: true
          },
          {
            key: 'homeUrl',
            label: this.$t('URL_HOME'),
            sortable: true
          },
          {
            key: 'userName',
            label: this.$t('USER'),
            sortable: true
          },
        ],
        myKey: 0,
        items: [{}],
        tblName: '',
        userName: '',
        curUserName: '',
        companyName: '',
        prefName: '',
        prefSearch: false,
        intLoc: this.$i18n.locale,
        item: {},
        selected: 'Company',
        curLang: '',
        status: 'false',
        action: '',
        helpName: 'HelpCompanyList',
        showHelp: false,
        perPage: 10,
        curPage: 1,
        listLength: 1,
        all: false
    }
  },
  mounted() {
    this.curUserName = this.$store.state.curUserName;
    //let all = this.$route.query.all;
    this.all = this.$route.query.all;
    //alert(this.all);
    //this.userName = this.$rmEncHyp(this.$route.params.userName);
    //this.fields[0].label = this.$t('TITLE');
    this.getList(this.all);
  },
  methods: {
    reloadList() {
        this.selected='Company';
        this.action = '';
        this.curPage = 1;
        //this.getList();
        if(this.prefSearch) this.search();
        else this.getList();
        this.myKey++;
    },
    async getList(all) {
        this.prefSearch = false;
        try {
            const response = await this.$http.get('/getCompaniesList', {
                params: {
                    pageNum: this.curPage,
                    listLoc: this.intLoc,
                    all: all
                }
            });
            this.items = response.data.itemList;
            if(this.items.length == 0) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                this.$router.go(-1);
            }
            else
                this.listLength = response.data.listLen;

/*
            if(this.items.length == 0) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                this.$router.go(-1);
            }
*/
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    onRowSelected(items) {
        this.item = items[0];
        this.companyName = this.item.companyName;
        this.userName = this.item.userName;
        if(this.selected==='Company') {
            window.open(this.item.homeUrl,'_blank');
        }
        else if(this.selected==='ManageCompany') {
            this.$router.push({
               path: '/ManageCompany/'+this.$addEncHyp(this.companyName),
            })
        }
        else if(this.selected==='RefAdd') {
            this.$router.push({
               path: '/ManageRef',
               query: {
                    userName: this.userName,
                    itemName: this.$addEncHyp(this.companyName),
                    itemType: 'c'
               }
            })
        }
        else if(this.selected==='CompanyOutingsList') {
            this.$router.push({
               path: '/CompanyOutingsList/'+this.$addEncHyp(this.companyName),
            })
        }
        else this.$bvModal.show('modalConf');
    },
    async canAct() {
        this.$bvModal.hide('modalConf');
        try {
            await this.$http.get('/'+this.selected, {
                params: {
                    companyName: this.companyName,
                    userName: this.curUserName
                }
            });
            this.$showMsg(this.$t('DONE'));
            this.reloadList();
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async search() {
        //alert(this.prefName);
        this.prefSearch = true;
        try {
            const response = await this.$http.get('/getPrefCompaniesList', {
                params: {
                    prefName: this.prefName,
                    pageNum: this.curPage,
                }
            });
            this.items = response.data.itemList;
            if(this.items.length == 0) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                //this.$router.go(-1);
            }
            else
                this.listLength = response.data.listLen;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },

  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.reloadList();
    },
    curPage: function() {
        if(this.prefSearch) this.search();
        else this.getList();
    }
  },
  computed: {
    rows() {
        return this.listLength;
    },
    author() { return this.userName === this.curUserName },
    admin() { return this.curUserName === 'admin' }
  }
}

</script>

<style>
#tbl1Name{
    font-size: 1.2em;
}
</style>
